/** @format */

import {
    CONVERTER_TYPE_DIE,
    CONVERTER_TYPE_DRAG_KNIFE,
    LAMINATES,
    SHAPE_CIRCLE,
    SHAPE_CUSTOM,
    SHAPE_OVAL,
    SHAPE_RECTANGLE,
    SHAPE_SQUARE,
    SIZE_STATUS_INSTOCK,
    SUBSTRATE_BACKINGS,
    SUBSTRATES
} from 'frontier-constants';

const orderFields = [
    {
        label: 'Substrate',
        field: 'substrate_id',
        type: 'list',
        listOptions: SUBSTRATES,
        jsonLogic: 'var'
    },
    {
        label: 'Laminate',
        field: 'laminate_id',
        type: 'list',
        listOptions: LAMINATES,
        jsonLogic: 'var'
    },
    {label: 'Width', field: 'width', type: 'number', jsonLogic: 'var'},
    {label: 'Length', field: 'length', type: 'number', jsonLogic: 'var'},
    {label: 'Converting Time', field: 'quoted_converting_time', type: 'number', jsonLogic: 'var'},
    {
        label: 'Converting Type',
        field: 'converter_type_id',
        type: 'list',
        listOptions: [
            {
                id: CONVERTER_TYPE_DIE,
                label: 'Die Cutter'
            },
            {
                id: CONVERTER_TYPE_DRAG_KNIFE,
                label: 'Drag Knife'
            }
        ],
        jsonLogic: 'var'
    },
    {
        label: 'Due Status',
        field: 'due_label',
        type: 'list',
        listOptions: [
            {id: 'late', label: 'Late'},
            {id: 'today', label: 'Today'},
            {id: 'tomorrow', label: 'Tomorrow'},
            {id: 'future', label: 'Future'}
        ],
        jsonLogic: 'var'
    },
    {
        label: 'Die Shape',
        field: 'size.shape_id',
        type: 'list',
        listOptions: [
            {id: SHAPE_RECTANGLE, label: 'Rectangle'},
            {id: SHAPE_CIRCLE, label: 'Circle'},
            {id: SHAPE_SQUARE, label: 'Square'},
            {id: SHAPE_OVAL, label: 'Oval'},
            {id: SHAPE_CUSTOM, label: 'Custom'}
        ],
        jsonLogic: 'var'
    },
    {
        label: 'Is Perforated',
        field: 'size.is_perforated',
        type: 'boolean',
        jsonLogic: 'var'
    },
    {
        label: 'Is Excluded from Drag Knife',
        field: 'size.is_excluded_from_drag_knife',
        type: 'boolean',
        jsonLogic: 'var'
    },
    {
        label: 'Die Status',
        field: 'size.status_id',
        type: 'list',
        listOptions: [{id: SIZE_STATUS_INSTOCK, label: 'In-Stock'}],
        jsonLogic: 'var'
    },
    {
        label: 'Backing Type',
        field: 'substrate_backing_id',
        type: 'list',
        listOptions: SUBSTRATE_BACKINGS,
        jsonLogic: 'var'
    },
    {label: 'Dual Anvil', field: 'is_dual_anvil', type: 'boolean', jsonLogic: 'var'},
    {label: 'VIP', field: 'user_company_is_vip', type: 'boolean', jsonLogic: 'var'},
    {label: 'New Customer', field: 'user_is_new_customer', type: 'boolean', jsonLogic: 'var'},
    {label: 'Run Length Feet', field: 'run_length_feet', type: 'number', jsonLogic: 'var'},
    {label: 'Expedite', field: 'is_expedited', type: 'boolean', jsonLogic: 'var'},
    {label: 'Total Qty', field: 'total_qty', type: 'number', jsonLogic: 'var'},
    {label: 'Frame File Qty', field: 'frame_file_count', type: 'number', jsonLogic: 'var'}
].sort((a, b) => a.label.localeCompare(b.label));

const operatorsByType = {
    boolean: ['==', '!='],
    datetime: ['==', '!=', '<', '<=', '>', '>='],
    date: ['==', '!=', '<', '<=', '>', '>='],
    text: ['==', '!=', 'contains', 'starts_with', 'ends_with'],
    number: ['==', '!=', '<', '<=', '>', '>='],
    list: ['==', '!=']
};

export {orderFields, operatorsByType};
